<div class="body">

    <mat-toolbar class="ams-toolbar">

        <button mat-icon-button>
            <mat-icon>cloud_queue</mat-icon>
        </button>

        <span>Datei wählen</span>

        <span class="spacer"></span>

        <button mat-icon-button (click)="close()" color="warn">
            <mat-icon>close</mat-icon>
        </button>

    </mat-toolbar>

    <div class="body-inner">

        <div class="header-wrapper">

            <div class="header">

                <div class="rootMetaData">
    
                    <span class="name">{{rootName$|async}}</span>
    
                    <span *ngIf="(files$|async)?.length === 1; else plural">Eine Datei,</span>
    
                    <ng-template #plural>
                        <span class="count">{{(files$|async)?.length}}</span>
                        <span>Dateien,</span>
                    </ng-template>
    
                    <span class="size">{{prettyRootSize$|async}}</span>
    
                </div>
    
                <app-nextcloud-path-navigator 
                    (pathChanged)="pathNavigatorChanged($event)" 
                    [pathArray]="rootPathArray$|async" 
                    [enableNavigation]=enableNavigation></app-nextcloud-path-navigator>
            
            </div>

            <div class="view-control">

                <input type="text" (keyup)="fileFilter = $event.target.value" />

                <mat-icon [class.active]="viewMode === FileViewModes.List" (click)="viewMode = FileViewModes.List">view_list</mat-icon>
                <mat-icon [class.active]="viewMode === FileViewModes.Tiles" (click)="viewMode = FileViewModes.Tiles">apps</mat-icon>
                
            </div>

        </div>

        <div class="content">

            <app-nextcloud-explorer 
                (onFileClick)="fileClick($event)" 
                (onFileDblClick)="fileDblClick($event)" 
                (fileSelected)="currentSelection = $event"
                [files]="files$|async" 
                [filter]="fileFilter" 
                [enableNavigation]=enableNavigation 
                [enableSelection]=true 
                [loading]="loading$|async" 
                [view]="viewMode" 
                [visibleTypes]="data.visibleTypes"
            ></app-nextcloud-explorer>

        </div>

        <div class="footer" *ngIf="data.showConfirmSelection">

            <button mat-raised-button [disabled]="!currentSelection" color="primary" (click)="close()">
                Übernehmen
            </button>
    
        </div>

    </div>
</div>
